import React from 'react'

export default function Mobile({
  className,
  width,
  height,
  color = '#000000'
}: {
  className?: string
  width?: number
  height?: number
  color?: string
}) {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 414.88 691.46698"
      version="1.1"
      id="svg1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs id="defs1" />
      <path
        d="m 414.87999,622.321 a 69.147,69.147 0 0 1 -69.147,69.146 H 69.145993 A 69.147,69.147 0 0 1 -6.8359375e-6,622.321 V 69.146998 A 69.147,69.147 0 0 1 69.145993,-2.4414063e-6 H 345.73299 A 69.147,69.147 0 0 1 414.87999,69.146998 Z m -51.722,-466.464 a 17.702,17.702 0 0 0 -17.286,-17.563 H 69.284993 a 17.702,17.702 0 0 0 -17.287,17.286 v 380.307 a 17.702,17.702 0 0 0 17.425,17.287 H 346.00999 a 17.702,17.702 0 0 0 17.287,-17.287 z m -112.294,-86.710002 h -86.848 a 8.6435,8.6435 0 0 0 0,17.287 h 86.433 a 8.6435,8.6435 0 1 0 0,-17.287 z M 207.57799,579.173 a 43.148,43.148 0 1 0 43.286,43.148 43.286,43.286 0 0 0 -43.286,-43.148 z"
        id="path1"
        fill={color}
      />
    </svg>
  )
}
